/**
 * Sanitize React `useId()` for the shaders package, which only allows alphanumeric and `_`
 * in node `id` props (see shaders/react ShaderComponent).
 * @param reactId Value from `useId()`
 * @returns Safe prefix for `shaders` component `id` props
 */
export function shaderIdPrefix(reactId: string): string {
  return reactId.replace(/[^a-zA-Z0-9_]/g, '_');
}
